import { useLocation } from "react-router-dom";

const Address = () => {
    const location = useLocation();

    const address = location.state?.address;
    return (
        <>
            <div className="text-blue-500">ini Address</div>
            <div className="text-blue-500">
                {address ? address : "gaada gan"}
            </div>
        </>
    );
};

export default Address;
